import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Field, Form } from "formik";
import axios, { AxiosError } from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loadImage from '../../images/giphy.gif';
import { DataAppContext } from '../../DataContext';

const Login = () => {
  const [loader, setLoader] = useState(false);
  const localContext = useContext(DataAppContext);
  const navigate = useNavigate();

  const login = async (values: { usernameOrEmail: string; password: string }) => {
    setLoader(true);
    const url = `${process.env.REACT_APP_API_URL}users/login`;

    try {
      const response = await axios.post(url, values);
      setLoader(false);

      if (response.status === 202) {
        const { token, userId, userType } = response.data;

        if (userType !== 'admin') {
          toast.error("Access Denied! Only admin can log in.");
          return;
        }

        localStorage.setItem('jwttoken', token);
        localStorage.setItem('userid', userId);
        localStorage.setItem('userType', userType);

        localContext.login_user();
        toast.success("Login successful!");
        navigate('/admindashboard');
      }
    } catch (err) {
      const axiosError = err as AxiosError;
    if (axiosError.response) {
      const { status } = axiosError.response;
      
      if (status === 401) {
        toast.error("Incorrect password.");
      } else if (status === 422) {
        toast.error("User not found.");
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } else {
      toast.error("Server connection failed. Please try again.");
    }
  } finally {
    setLoader(false);
  }
};

  return (
    <>
      <ToastContainer />
      <div className='row maincontent'>
        <div className='col-md-3 col-xs-12'></div>
        <div className='col-md-6 col-xs-12'>

          <Formik
            initialValues={{ usernameOrEmail: "", password: "" }}
            onSubmit={async (values, { resetForm }) => {
              await login(values);
             // resetForm();
            }}
          >
            {({ isSubmitting }) => (
              <Form className='login-form'>
                <br />
                <div className="form-group row">
                  <label className="col-sm-5 col-form-label">Username/Email/Mobile*</label>
                  <div className='col-sm-7'>
                    <Field name="usernameOrEmail" type="text" className="form-control" required />
                  </div>
                </div>

                <div className="form-group row mt-2">
                  <label className="col-sm-5 col-form-label">Password*</label>
                  <div className='col-sm-7'>
                    <Field name="password" type="password" className="form-control" required />
                  </div>
                </div>
                <br />
                <button type="submit" className='btn btn-primary' disabled={loader || isSubmitting}>
                  {loader ? "Logging in..." : "Admin Login"}
                </button>
                <br />
              </Form>
            )}
          </Formik>

        </div>
        <div className='col-md-3 col-xs-12'></div>

        {loader && (
          <div className="d-flex justify-content-center align-items-center position-fixed ">
            <img src={loadImage} alt="Loader" />
          </div>
        )}
      </div>
    </>
  );
};

export default Login;
